













import { defineComponent } from '@nuxtjs/composition-api'
import { provideProductList,injectProductList } from '~/composables/product/useProductList'

export default defineComponent({
  name: 'SidebarProductFilter',

  setup() {
    // provideProductList()
    const { loading } = injectProductList()
    // console.log(products,'test filters')
    return {
      loading,
      // provideProductList
      // loading,
    }
  },
})
